export default __webpack_public_path__ + "static/media/go.50341d42.png";